import { Helmet } from 'react-helmet';
import { useLocale } from '../../contexts/LocaleContext';
import buildShopProductsJsonLd, { ShopProductForJsonLd } from '../../lib/shopProductsJsonLd';
import * as types from '../../types';

interface ShopProductsJsonLdProps {
  products: ShopProductForJsonLd[];
  discountsByKey: Record<string, types.HardwareDiscountPreview | undefined>;
}

/** Product JSON-LD for the pick-your-fi shop; see `buildShopProductsJsonLd` for what it publishes and why. */
export default function ShopProductsJsonLd({ products, discountsByKey }: ShopProductsJsonLdProps) {
  const { currency, country } = useLocale();
  const jsonLd = buildShopProductsJsonLd(products, discountsByKey, currency, country, window.location.origin);
  if (!jsonLd) {
    return null;
  }
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  );
}
